export default "__VITE_ASSET__Bgvg1IKu__"